import React from "react";

interface CardProps {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  bodyClassName?: string;
  /** Render children edge-to-edge (tables, lists). */
  flush?: boolean;
  interactive?: boolean;
}

/** Surface container with an optional header row. */
export const Card = ({
  title,
  subtitle,
  actions,
  children,
  className = "",
  bodyClassName = "",
  flush = false,
  interactive = false,
}: CardProps) => (
  <section className={`zs-card ${interactive ? "zs-card-interactive" : ""} ${className}`}>
    {(title || actions) && (
      <div className="zs-card-header">
        <div className="min-w-0">
          {title && <h2 className="zs-card-title">{title}</h2>}
          {subtitle && <p className="mt-0.5 zs-card-subtitle">{subtitle}</p>}
        </div>
        {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
      </div>
    )}
    <div className={flush ? bodyClassName : `zs-card-body ${bodyClassName}`}>{children}</div>
  </section>
);
